<!--
  - Copyright (c) 2020 brightlamp
  -->

<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="400">
            <v-card >
                <v-card-title class="headline" style="color:#FFFD00;background-color:#363636;">Add a Card</v-card-title>
                <div class="ma-4" ref="card"></div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
                    <v-btn color="blue darken-1" :loading="waiting" :disabled="stripeError || waiting || !complete" text @click="addCard">Add Card</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'add-credit-card-dialog',
        data: function ()
        {
            return {
                dialog: Boolean(true),
                stripeError: Boolean(true),
                complete: Boolean(false)
            }
        },
        props:
        {
            forOrg: null
        },
        async mounted()
        {
            this.$logEvent(this.$firebaseAnalytics, 'screen_view',
            {
                app_name: 'Web Portal',
                screen_name: `Reflex Web Portal - ${this.$options.name}`,
                app_version: process.env.VUE_APP_VERSION
            });
            this.setUpStripe()
        },
        computed:
        {
            ...mapState('customerBilling',
            {
                paymentInfo: state => state.paymentInfo
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        methods:
        {
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            ...mapActions('customerBilling', ['SET_PAYMENT_INFO', 'SET_ORG_PAYMENT_INFO']),
            setUpStripe()
            {
                if (window.Stripe === undefined)
                {
                    this.SHOW_SNACKBAR_ERROR('Stripe V3 library not loaded!')
                }
                else
                {
                    /*eslint-disable */
                    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
                    /*eslint-enable */
                    const elements = this.stripe.elements();

                    const style =
                    {
                        base:
                        {
                            fontSize: '16px',
                            color: "#000000",
                        }
                    };
                    this.card = elements.create('card', {style});
                    this.card.mount(this.$refs.card);

                    this.card.addEventListener('change', (event) =>
                    {
                        this.complete = event.complete;
                        if (event.error)
                        {
                            this.stripeError = true;
                            this.SHOW_SNACKBAR_ERROR(event.error.message)
                        }
                        else if (event.complete)
                        {
                            this.stripeError = false
                        }
                    })
                }
            },
            async addCard()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    const result = await this.stripe.createToken(this.card);
                    if (!result.error)
                    {
                        this.paymentInfo.cards.push({cardToken: result.token.id});
                        if (this.forOrg)
                        {
                            await this.SET_ORG_PAYMENT_INFO({orgId: this.forOrg, data: this.paymentInfo})
                        }
                        else
                        {
                            await this.SET_PAYMENT_INFO(this.paymentInfo)
                        }
                        this.stripeError = true;
                        this.card.clear();
                        this.$emit('add-credit-card-dialog-response')
                    }
                    else
                    {
                        this.SHOW_SNACKBAR_ERROR(result.error)
                    }
                    this.WAITING(false)
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message);
                    this.WAITING(false);
                    this.cancel(true)
                }
            },
            cancel(reload = false)
            {
                this.$emit('add-credit-card-dialog-response', reload)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .currentPaymentSource
    {
        color: black;
        font-size: large;
    }
</style>